define('modules/reporting/campaigns/siteTransparency/views/grid',["jQuery", "Underscore", "Mustache", "T1", "T1View", "T1GridViewV2", "T1PerformanceTimer", "text!../templates/grid_header.html", "text!../templates/grid_footer.html", "text!../templates/item.html", "text!../templates/subitem.html"], function ($, _, Mustache, T1, T1View, T1GridView, T1Timer, gridHeaderTemplate, gridFooterTemplate, itemTemplate, subItemTemplate) {
  "use strict";

  var $window = $(window);
  var viewportHeight = $window.height() || 0;
  var viewportLeft = $window.scrollLeft() || 0;
  var formatCurrency = T1.Utils.formatCurrency;
  var formatAs = T1.Formats.as;
  var GAMap = {
    render: "RPTG:SITE:GRID:RENDER"
  };
  var GridView = T1View.extend({
    selected: "",
    partials: {
      gridFooter: gridFooterTemplate,
      gridHeader: gridHeaderTemplate,
      listItem: itemTemplate
    },
    keys: [],
    headers: [],
    mainKey: "strategy_name",
    dimensionKey: "strategy_id",
    scrollVLimit_chartOn: 546,
    scrollVLimit_chartOff: 192,
    $masterCheckBox: {},
    $masterStyledCheckBox: {},
    section: "siteTransparency",
    sortConfigs: {
      order: {
        default: "descending",
        custom: {
          Strategy_Name: "ascending"
        }
      },
      sortBy: function (sortKey, sortOrder) {
        var isName = this.keys[0] === sortKey ? "1" : "0";
        var order = sortOrder === "ascending" ? 1 : -1;
        this.reportModel.setSortKeyInfo(`${sortKey},${order},${isName}`);
      }
    },
    events: {
      "click .checkbox-styled": "stopBubbling",
      "click .icon": "toggleOpen",
      "click .item": "toggleHighlighted",
      "click .legend-chart": "toggleSelected",
      'click input[type="checkbox"]': "toggleCheckbox"
    },
    dataEvents: {
      collection: {
        sort: "tableSorted"
      },
      reportModel: {
        "change:columnKeys": "reload",
        "change:dimensionItems": "reload",
        "change:filteredOutItems": "filterOutItems",
        "change:highlightedItem": "highlightItem"
      }
    },
    eventhubEvents: {
      "chart.toggle": "chartToggled",
      "chart.toggleEnd": "chartToggleEnded",
      "createSiteList.done": "resetCheckboxes",
      "update:grid:title": "reload"
    },
    stopBubbling: function (event) {
      event.stopPropagation();
    },
    initialize: function (args) {
      var self = this;
      var models = args.models;
      this.reportMeta = models.reportMeta;
      this.mainModel = models.mainModel;
      this.reportModel = models.reportModel;
      this.campaign = models.campaign;
      this.collection = args.dataGroup.collection;
      this.dailyCollection = args.dataGroup.dailyCollection;
      this.type = args.type;
      this.scrollVLimit = this.scrollVLimit_chartOn;
      this.appTop = 82;
      this.gridLeft = 113;
      this.gridHeader = $("");
      this.gridHeaderMode = null;
      this.onScrollVHProxy = $.proxy(this.onScrollVH, this);
      this.viewportResizeListener = function () {
        viewportHeight = $window.height() || 0;
        self.updateScrollBar();
        self.shiftScrollbar($window.scrollTop());
      };
      this.bindViewEvents();
    },
    load: function () {
      if (this.mainModel.leftTheSection(this.section)) {
        return;
      }
      const self = this;
      const $el = this.el;
      let $contentHolder, offset;
      if (!this.reportModel.get("columnKeys")) {
        return;
      }
      const timerData = {
        category: GAMap.render,
        label: this.campaign.id
      };
      $window.off("scroll", this.onScrollVHProxy).on("scroll", this.onScrollVHProxy);
      $window.off("resize", this.viewportResizeListener).on("resize", this.viewportResizeListener);
      T1Timer.start(timerData);
      this.sortData(true);
      this.prepareRenderData();
      this.prepareGridData();
      this.render().then(function () {
        self.recalculateSettings();
        T1Timer.stop(timerData);
      });
      setTimeout(function () {
        self.$masterCheckBox = $el.find("input[type=checkbox].master");
        self.$masterStyledCheckBox = $el.find(".checkbox-styled.master");
      }, 0);
      const $wDataGrid = $el.find(".w-DataGrid");
      const $gridHeaderContainer = $wDataGrid.find(".header-container");
      const $gridContentContainer = $wDataGrid.find(".content-c");
      this.$contentHolder = $contentHolder = $wDataGrid.find(".content-holder");
      $contentHolder.off("scroll").on("scroll", function () {
        if ($gridHeaderContainer) {
          $gridHeaderContainer.css("left", `${-$contentHolder.scrollLeft()}px`);
        }
      });
      offset = $wDataGrid.find(".content-holder").offset();
      if (offset !== null) {
        this.gridLeft = offset.left;
      }
      offset = $(".app-container").offset();
      if (offset !== null) {
        this.appTop = offset.top;
      }
      const gridHeaderPadding = Number($gridHeaderContainer.css("padding-left").replace("px", ""));
      if ($gridHeaderContainer.width() + gridHeaderPadding > $gridContentContainer.width()) {
        $gridContentContainer.width(Number($gridHeaderContainer[0].scrollWidth) + gridHeaderPadding);
      }
      this.recalculateSettings();
    },
    unload: function () {
      if (this.$contentHolder) {
        this.$contentHolder.off("scroll");
      }
      $window.off("resize", this.viewportResizeListener);
      $window.off("scroll", this.onScrollVHProxy);
      this.itemCount = null;
      this.nestedItemLookup = null;
    },
    tableSorted: function () {
      this.reload();
    },
    recalculateSettings: function () {
      this.chartToggled(this.mainModel.get("chartShown") === "true");
      this.recalculateSettingsForHeader();
      this.recalculateSettingsForScrollbar();
    },
    recalculateSettingsForHeader: function () {
      var el = this.el;
      var gridHeader = el.find(".w-DataGrid .w-head");
      if (this.gridHeader[0] !== gridHeader[0]) {
        this.gridHeader = gridHeader;
        this.gridHeaderMode = null;
      }
      this.shiftHeader($window.scrollTop(), $window.scrollLeft());
    },
    recalculateSettingsForScrollbar: function () {
      var el = this.el;
      var gridList = el.find(".content-c");
      var gridListOffset = gridList.offset();
      var gridListTop = gridListOffset ? gridListOffset.top : 0;
      var gridListHeight = gridList.height() || 0;
      var gridListBottom = gridListTop + gridListHeight;
      var $contentHolder = this.$contentHolder;
      if ($contentHolder) {
        this.scrollbar = $contentHolder.find(".ps-scrollbar-x");
        this.scrollbarRangeStart = gridListTop;
        this.scrollbarRangeEnd = gridListBottom;
        if (!this.scrollbar[0]) {
          this.scrollbarRangeEnd = this.scrollbarRangeStart;
        }
        this.shiftScrollbar($window.scrollTop());
      }
    },
    onScrollVH: function () {
      var scrollTop = $window.scrollTop();
      var scrollLeft = $window.scrollLeft();
      this.shiftHeader(scrollTop, scrollLeft);
      this.shiftScrollbar(scrollTop);
    },
    shiftHeader: function (scrollTop, scrollLeft) {
      var gridHeader = this.gridHeader;
      var adjustHorizontally = false;
      var isFrozen = this.gridHeaderMode === "frozen";
      if (!gridHeader[0]) {
        return;
      }
      if (viewportLeft !== scrollLeft) {
        viewportLeft = scrollLeft;
        adjustHorizontally = true;
      }
      if (!isFrozen && scrollTop >= this.scrollVLimit) {
        this.gridHeaderMode = "frozen";
        gridHeader.css({
          left: `${this.gridLeft - viewportLeft}px`,
          position: "fixed",
          top: `${this.appTop}px`,
          zIndex: "2"
        });
        adjustHorizontally = false;
      } else if (this.gridHeaderMode !== "normal" && scrollTop < this.scrollVLimit) {
        this.gridHeaderMode = "normal";
        gridHeader.css({
          left: "0",
          position: "absolute",
          top: "auto",
          zIndex: "auto"
        });
      }
      if (adjustHorizontally && isFrozen) {
        gridHeader.css("left", `${this.gridLeft - viewportLeft}px`);
      }
    },
    shiftScrollbar: function (scrollTop) {
      var viewportBottom, viewportBottomInRange;
      var scrollbar = this.scrollbar;
      var $contentHolder = this.$contentHolder;
      if (!scrollbar[0]) {
        return;
      }
      viewportBottom = scrollTop + viewportHeight;
      viewportBottomInRange = this.scrollbarRangeStart < viewportBottom && this.scrollbarRangeEnd > viewportBottom;
      if (viewportBottomInRange) {
        scrollbar.css({
          "margin-left": `${this.gridLeft}px`,
          bottom: "2px",
          position: "fixed"
        });
        $contentHolder.perfectScrollbar("freezeX");
      } else {
        scrollbar.css({
          "margin-left": 0,
          position: "absolute"
        });
        $contentHolder.perfectScrollbar("thawX");
      }
      $contentHolder.perfectScrollbar("update");
    },
    chartToggled: function (chartShown) {
      this.scrollVLimit = chartShown ? this.scrollVLimit_chartOn : this.scrollVLimit_chartOff;
    },
    chartToggleEnded: function () {
      if (this.scrollVLimit === this.scrollVLimit_chartOff && $window.scrollTop() > this.scrollVLimit) {
        $window.scrollTop(this.scrollVLimit);
      }
      this.recalculateSettingsForHeader();
      this.recalculateSettingsForScrollbar();
    },
    toggleOpen: function (e) {
      var selectedItem = $(e.target).closest(".item");
      var selectedArrow = $(e.target).closest(".arrow");
      var expandedClass = "expanded";
      var loadingClass = "loading";
      var action;
      const appendChildList = this.appendChildList;
      if (selectedItem.hasClass(expandedClass)) {
        action = "conceal";
        selectedItem.removeClass(expandedClass);
        selectedArrow.removeClass(loadingClass);
      } else {
        action = "reveal";
        selectedItem.addClass(expandedClass);
        selectedArrow.addClass(loadingClass);
        appendChildList.call(this, e);
      }
      this.recalculateSettingsForScrollbar();
      e.preventDefault();
      if (selectedItem.hasClass("selected")) {
        e.stopPropagation();
      }
      T1.EventHub.publish("track:event", {
        action: "Disclose time series",
        label: action
      });
    },
    appendChildList: function (event) {
      var ele = $(event.target);
      var id = ele.attr("data-id");
      var childRow = ele.closest(".item-row").find(".child-row");
      var html, list;
      list = this.nestedItemLookup[id];
      if (!list || childRow.data("loaded")) {
        return;
      }
      html = Mustache.to_html(subItemTemplate, {
        list: list
      });
      childRow.html(html);
      childRow.data("loaded", true);
      event.preventDefault();
    },
    sortData: function (silent) {
      var key, order, sortKeyArray;
      var sortKeyInfo = this.reportModel.get("sortKeyInfo") || "";
      const SORT_KEY = 0;
      const SORT_ORDER = 1;
      const TIME_SERIES = 2;
      if (sortKeyInfo.length > 0) {
        sortKeyArray = sortKeyInfo.split(",");
        key = sortKeyArray[SORT_KEY];
        order = parseInt(sortKeyArray[SORT_ORDER], 10);
        this.collection.sortByKey(key, order, this.type, silent, parseInt(sortKeyArray[TIME_SERIES], 10));
      }
    },
    setAllNoneClass: function () {
      var reportModel = this.reportModel;
      var hiddenCount = reportModel.getHiddenItemsCount();
      var benchMark = reportModel.get("campaignBenchmarkOn");
      var $legend = $(".header-container .legend-chart.header", this.el);
      if (hiddenCount || !benchMark) {
        $legend.addClass("hide");
      } else {
        $legend.removeClass("hide");
      }
    },
    toggleAll: function (target) {
      var reportModel = this.reportModel;
      var allHidden = target.hasClass("hide");
      var itemsToHide;
      var idList = {};
      var $legend = this.el.find(".legend-chart");
      if (allHidden) {
        reportModel.resetHiddenItems();
        $legend.removeClass("hide");
      } else {
        $legend.addClass("hide");
        itemsToHide = reportModel.get("siteList");
        $.each(itemsToHide, function (i, item) {
          idList[item.id] = true;
        });
        reportModel.setHiddenItems(idList);
      }
    },
    toggleSelected: function (e) {
      var target = $(e.target);
      var item = target.closest(".item");
      e.stopPropagation();
      if (target.hasClass("header")) {
        this.toggleAll(target);
        return;
      }
      target.toggleClass("hide");
      this.reportModel.setHiddenItem({
        action: target.hasClass("hide") ? "hide" : "show",
        id: String(item.data("id")),
        type: "strategy"
      });
      T1.EventHub.publish("track:event", {
        action: "Add/remove row from chart",
        label: "legend-chart"
      });
      this.setAllNoneClass();
    },
    toggleHighlighted: function (e) {
      var item = $(e.currentTarget);
      var target = $(e.target);
      e.stopPropagation();
      if (target.hasClass("label")) {
        return;
      }
      this.reportModel.setHighlightedItem({
        from: "row",
        id: item.hasClass("selected") ? null : String(item.data("id")),
        type: "strategy"
      });
    },
    toggleCheckbox: function (evt) {
      var $clickedCheckBox = $(evt.target);
      var $masterStyledCheckBox = this.$masterStyledCheckBox;
      var $masterCheckBox = this.$masterCheckBox;
      var id = $clickedCheckBox.closest(".item").attr("data-id");
      var isMasterCheckbox = $clickedCheckBox.hasClass("master");
      var isChecked = $masterCheckBox.is(":checked");
      var reportModel = this.reportModel;
      var siteList = reportModel.get("siteList");
      evt.stopPropagation();
      reportModel.setMarkedSite(id, isMasterCheckbox, isChecked);
      if (isMasterCheckbox) {
        this.toggleMasterCheckbox(isChecked);
      } else {
        switch (reportModel.get("sitesMarkedCount")) {
          case 0:
            $masterCheckBox.prop("checked", false);
            $masterStyledCheckBox.removeClass("indeterminate");
            this.toggleCreateSiteListBtn(false);
            break;
          case siteList.length:
            $masterCheckBox.prop("checked", true);
            $masterStyledCheckBox.removeClass("indeterminate");
            this.toggleCreateSiteListBtn(true);
            break;
          default:
            $masterCheckBox.prop("checked", true);
            $masterStyledCheckBox.addClass("indeterminate");
            this.toggleCreateSiteListBtn(true);
        }
        T1.EventHub.publish("grid.markSite");
      }
    },
    toggleMasterCheckbox: function (isChecked) {
      var $masterStyledCheckBox = this.$masterStyledCheckBox;
      var $masterCheckBox = this.$masterCheckBox;
      var reportModel = this.reportModel;
      if ($masterStyledCheckBox.hasClass("indeterminate")) {
        $masterStyledCheckBox.removeClass("indeterminate");
        isChecked = !isChecked;
        $masterCheckBox.prop("checked", isChecked);
        reportModel.setMarkedSite(undefined, true, isChecked);
      }
      this.toggleCreateSiteListBtn(isChecked);
      this.el.find(".w-body .item input:enabled").prop("checked", isChecked);
      T1.EventHub.publish("grid.markSite");
    },
    resetCheckboxes: function () {
      this.$masterStyledCheckBox.removeClass("indeterminate");
      this.$masterCheckBox.prop("checked", false);
      this.toggleMasterCheckbox(false);
      this.reportModel.setMarkedSite(undefined, true, false);
    },
    toggleCreateSiteListBtn: function (activateBtn) {
      var $siteListBtn = $(".w-GridControls .site-list");
      if (activateBtn) {
        $siteListBtn.removeClass("disabled");
      } else {
        $siteListBtn.addClass("disabled");
      }
    },
    highlightItem: function (model) {
      var contentC = $(this.el).find(".content-c");
      var highlightedItem = model.get("highlightedItem");
      contentC.children(".item").removeClass("selected");
      if (highlightedItem && highlightedItem.id !== null) {
        contentC.find(`.item[data-id="${highlightedItem.id}"]`).addClass("selected");
      }
    },
    filterOutItems: function (model) {
      var filteredInItem, filteredOutItem;
      var $contentC = this.el.find(".content-c");
      var filterOutClass = "filter-out";
      var filteredOutItems = model.get("filteredOutItems") || [];
      var filteredInItems = model.get("filteredInItems") || [];
      var count = this.reportModel.getFilteredInCount();
      for (let i = 0, outLength = filteredOutItems.length; i !== outLength; i++) {
        filteredOutItem = filteredOutItems[i];
        $contentC.find(`.item[data-id="${filteredOutItem.replace(/[']/g, "")}"]`).addClass(filterOutClass);
      }
      for (let inLength = filteredInItems.length, j = 0; j !== inLength; j++) {
        filteredInItem = filteredInItems[j];
        $contentC.find(`.item[data-id="${filteredInItem.replace(/[']/g, "")}"]`).removeClass(filterOutClass);
      }
      this.updateDataBind({
        count: count,
        total_count: count
      }, ".w-foot");
    },
    prepareRenderData: function () {
      this.mainKey = this.dimensionKey = this.reportModel.get("dimensionInfo").key;
    },
    prepareGridData: function () {
      var reportMetaObj, reportModelObj;
      var headers = [];
      var reportModel = this.reportModel;
      var sortKeyInfo = reportModel.get("sortKeyInfo") || "";
      var sortKeyArray = sortKeyInfo.split(",");
      var sortKey = sortKeyArray[0];
      var sortOrder = parseInt(sortKeyArray[1], 10);
      var columns = {};
      var firstHeader = {};
      this.reportMetaObj = $.extend({}, this.reportMeta.toJSON());
      reportMetaObj = this.reportMetaObj;
      this.reportModelObj = $.extend({}, reportModel.toJSON());
      reportModelObj = this.reportModelObj;
      this.keys = [this.mainKey].concat(reportModelObj.columnKeys);
      firstHeader[this.mainKey] = "DOMAIN";
      columns = $.extend(firstHeader, reportModelObj.formattedHeaderValues);
      $.each(this.keys, function (i, n) {
        var field = reportMetaObj.fields[n];
        var format = field.type;
        var label = columns[n];
        headers.push({
          ascending: sortOrder === 1,
          field: n,
          firstHeader: i === 0,
          format: format,
          isSortable: true,
          label: label,
          name: format,
          showSortOrder: n === sortKey
        });
      });
      this.headers = headers;
    },
    prepareListForNoDataMessage: function (list) {
      const ROW_THREE = 2;
      for (let i = 0, length = 4; i !== length; i++) {
        list.push({
          blank: "blank",
          id: "",
          isCampaignRow: false,
          msg: ""
        });
      }
      list[ROW_THREE].msg = "No data available for this selection";
      list[ROW_THREE].blank = "";
      return list;
    },
    serialize: function () {
      var self = this;
      var reportModel = this.reportModel;
      var mainModel = this.mainModel;
      var collection = this.collection;
      var dailyCollection = this.dailyCollection;
      var summaryItemJson = collection && collection.loaded ? collection.toJSON() : [];
      var dailyData = dailyCollection && dailyCollection.loaded ? dailyCollection.toJSON() : [];
      var reportMetaObj = this.reportMetaObj;
      var list = [];
      var keys = this.keys;
      var item = {
        keys: []
      };
      var highlightedItem = reportModel.get("highlightedItem");
      var highlightedStrategy = highlightedItem && highlightedItem.type === "strategy" ? highlightedItem : null;
      var hiddenItems = reportModel.get("hiddenItems") || {};
      var filteredOutItems = reportModel.get("filteredOutItems") || [];
      var colorData = reportModel.get("colorData");
      var itemsHidden = reportModel.getHiddenItemsCount();
      var dimensionItemsCount = reportModel.get("dimensionItemsCount");
      var filteredInCount = reportModel.get("filteredInCount");
      var count;
      var currencyCode = "USD";
      var siteLookup = reportModel.get("siteLookup");
      var allSitesMarked = false;
      var someSitesMarked = false;
      var siteListAccess = mainModel.get("strategyAccess") === "edit";
      var masterCheckBoxInactive = false;
      var validSiteList = reportModel.get("validSiteList");
      var searchTerm = reportModel.getSearchTerm().toLowerCase();
      var isSiteDomain = this.dimensionKey === "site_domain";
      var isCTD = reportModel.get("isCTD");
      var searchedDomains = reportModel.getSearchedItems() || [];
      var validSiteCount = 0;
      if (summaryItemJson && colorData) {
        _.each(summaryItemJson, function (rowData) {
          var id = rowData[self.dimensionKey];
          item = {
            keys: []
          };
          item.id = id = id && id.replace(/[']/g, "");
          item.isSelected = highlightedStrategy && highlightedStrategy.id === id;
          item.isFilteredOut = filteredOutItems.indexOf(id) > -1;
          item.invalid = isSiteDomain ? !validSiteList[id] : false;
          if (searchTerm === "" || searchTerm !== "" && rowData.site_domain.toLowerCase().indexOf(searchTerm) !== -1) {
            if (!item.invalid) {
              item.marked = siteLookup && siteLookup[id] ? siteLookup[id].marked : false;
              validSiteCount++;
            }
            _.each(keys, function (metric) {
              var formattedValue;
              const format = reportMetaObj.fields[metric].type;
              const value = rowData[metric] ? rowData[metric] : "--";
              if (value === "--") {
                formattedValue = value;
              } else if (format === "currency") {
                formattedValue = formatCurrency(value, null, currencyCode);
              } else {
                formattedValue = formatAs(format)(value);
              }
              item.keys.push({
                checked: !hiddenItems[id],
                colorIndex: colorData[id] + 1,
                format: format,
                isCTD: isCTD,
                isName: metric === self.mainKey,
                siteListAccess: siteListAccess,
                value: formattedValue
              });
            });
            list.push(item);
          }
        });
      }
      if (colorData && dailyData && dailyData.length && !isCTD) {
        const groupedData = _.groupBy(dailyData, this.dimensionKey);
        const sortedData = _.mapObject(groupedData, data => _.sortBy(data, "start_date"));
        const nestedItemLookup = _.mapObject(sortedData, function (dataSet) {
          var nestedItems = [];
          _.each(dataSet, function (dayObj) {
            var nestedItem = {
              keys: []
            };
            _.each(keys, function (metric) {
              var formattedValue, isName;
              const format = reportMetaObj.fields[metric].type;
              const value = dayObj[metric] ? dayObj[metric] : "--";
              if (value === "--") {
                formattedValue = value;
              } else if (format === "currency") {
                formattedValue = formatCurrency(value, null, currencyCode);
              } else {
                formattedValue = formatAs(format)(value);
              }
              isName = metric === self.mainKey;
              nestedItem.keys.push({
                format: isName ? "date" : format,
                isName: false,
                value: isName ? dayObj.start_date : formattedValue
              });
            });
            nestedItems.push(nestedItem);
          });
          return nestedItems;
        });
        this.nestedItemLookup = nestedItemLookup;
      }
      this.itemCount = reportModel.get("filteredOutCount") === 0 ? dimensionItemsCount : filteredInCount;
      count = list.length;
      if (reportModel.get("dimensionItems") && this.itemCount === 0 || searchTerm !== "" && count === 0) {
        list = this.prepareListForNoDataMessage(list);
        masterCheckBoxInactive = true;
      }
      if (summaryItemJson.length > 0) {
        reportModel.setSiteList(list);
        switch (reportModel.get("sitesMarkedCount")) {
          case 0:
            this.toggleCreateSiteListBtn(false);
            break;
          case validSiteCount:
          case searchedDomains.length:
            allSitesMarked = true;
            this.toggleCreateSiteListBtn(true);
            break;
          default:
            allSitesMarked = true;
            someSitesMarked = true;
            this.toggleCreateSiteListBtn(true);
        }
      }
      return {
        allMarked: allSitesMarked,
        contentType: "summary-grid",
        hideNoResultMessage: true,
        isExpandable: true,
        itemsHidden: itemsHidden,
        list: list,
        masterInactive: masterCheckBoxInactive,
        partiallyMarked: someSitesMarked,
        pageControls: {
          count: count,
          total: count
        },
        siteListAccess: siteListAccess
      };
    }
  });
  return T1GridView(GridView);
});
